import { downloadBlob, downloadBlobFromResponse, getFileUrlFromResponse } from '../../Scripts/FileUtilities';
import { createMapPdfDocument } from './siteMaps/MapPdfService';

export async function handleStandardDocumentResponse({
    document,
    downloadBlobFromResponseFn = downloadBlobFromResponse,
    getFileUrlFromResponseFn = getFileUrlFromResponse,
    onDownloadFinished,
    response,
    setViewDocumentData,
    viewDocument = false,
}) {
    function runOnDownloadFinished() {
        if (onDownloadFinished) {
            onDownloadFinished();
        }
    }

    function updateViewerDocumentData(viewerDocumentData) {
        if (setViewDocumentData) {
            setViewDocumentData(viewerDocumentData);
        }
    }

    if (!response.ok) {
        return Promise.reject(response);
    }

    if (viewDocument === false) {
        const fileName = await downloadBlobFromResponseFn(response);
        runOnDownloadFinished();
        return fileName;
    }

    const url = await getFileUrlFromResponseFn(response);
    updateViewerDocumentData({
        download: false,
        filename: document.fileName,
        src: url,
        type: document.mimeType,
    });
    runOnDownloadFinished();
    return url;
}

export async function createMapPdfFromRevisionResponse({
    createMapPdfDocumentFn = createMapPdfDocument,
    getFileUrlFromResponseFn = getFileUrlFromResponse,
    map,
    response,
    revision,
    revokeObjectUrlFn = url => URL.revokeObjectURL(url),
    site,
}) {
    if (!response.ok) {
        return Promise.reject(response);
    }

    let mapImageUrl;

    try {
        mapImageUrl = await getFileUrlFromResponseFn(response);
        return await createMapPdfDocumentFn({
            map,
            mapImageUrl,
            revision,
            site,
        });
    }
    finally {
        if (mapImageUrl) {
            revokeObjectUrlFn(mapImageUrl);
        }
    }
}

export async function handleMapDocumentResponse({
    createMapPdfFromRevisionResponseFn = createMapPdfFromRevisionResponse,
    createObjectUrlFn = blob => URL.createObjectURL(blob),
    downloadBlobFn = downloadBlob,
    map,
    onDownloadFinished,
    response,
    revision,
    setViewDocumentData,
    site,
    viewDocument = false,
}) {
    function runOnDownloadFinished() {
        if (onDownloadFinished) {
            onDownloadFinished();
        }
    }

    function updateViewerDocumentData(viewerDocumentData) {
        if (setViewDocumentData) {
            setViewDocumentData(viewerDocumentData);
        }
    }

    const pdfDocument = await createMapPdfFromRevisionResponseFn({
        map,
        response,
        revision,
        site,
    });

    if (viewDocument === false) {
        downloadBlobFn(pdfDocument.blob, pdfDocument.fileName);
        runOnDownloadFinished();
        return pdfDocument.fileName;
    }

    const pdfUrl = createObjectUrlFn(pdfDocument.blob);
    updateViewerDocumentData({
        download: false,
        filename: pdfDocument.fileName,
        src: pdfUrl,
        type: 'application/pdf',
    });
    runOnDownloadFinished();
    return pdfUrl;
}
